import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Faltan VITE_SUPABASE_URL o VITE_SUPABASE_ANON_KEY. Copia app/.env.example a app/.env.local y completa los valores.',
  );
}

/** Cliente único de Supabase para toda la app (auth + datos + storage). */
export const supabase: SupabaseClient = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: 'treid-campo-auth',
  },
  global: {
    headers: { 'x-client-info': 'treid-campo-web' },
  },
});
